const AvailableThemes = Object.freeze({
  DEFAULT: 'default',
  ADMIN: 'admin',
} as const);

export type AvailableThemes = (typeof AvailableThemes)[keyof typeof AvailableThemes];

export default AvailableThemes;
